import SavedMessagesServices from "../saved-messages";
import { language } from "../../stores/storages/LanguageStorage"
import { clientInfo } from "../../version";
import { profile } from "../../stores/storages/ProfileStorage";
import formatter from '../formatter'
import Helpers from '../../lib/helpers';
import { Topic } from "../../tinode/topic";

class SavedMessages {
   async delMessage(id) {
      const timestamp = new Date().getTime();
      const token = profile.token;
      const resource = clientInfo.platform;
      const msisdn = profile.username;
      const security = formatter.encrypt(`${msisdn}${resource}${token}${timestamp}`, true);
      const formData = new FormData();
      formData.set('msisdn', msisdn);
      formData.set('listMessageId', JSON.stringify([id]));
      formData.set('resource', resource);
      formData.set('timestamp', timestamp);
      formData.set('security', security);
      formData.set('clientType', resource);
      formData.set('revision', clientInfo.revision);
      formData.set('languageCode', language.language);
      formData.set('countryCode', clientInfo.country);
      const res = await SavedMessagesServices.deleteMessage(formData, { decrypt: false });
      return await (res.code === 200 ? Promise.resolve(res) : Promise.reject(res));
   }

   async editMessage(id, content) {
      const timestamp = new Date().getTime();
      const msisdn = profile.username;
      const resource = clientInfo.platform;
      const token = profile.token;
      const security = formatter.encrypt(`${msisdn}${id}${resource}${token}${timestamp}`, true);
      const formData = new FormData();
      formData.set('msisdn', msisdn);
      formData.set('messageId', id);
      formData.set('resource', resource);
      formData.set('content', content)
      formData.set('timestamp', timestamp);
      formData.set('security', security);
      formData.set('clientType', resource);
      formData.set('revision', clientInfo.revision);
      formData.set('languageCode', language.language);
      formData.set('countryCode', clientInfo.country);
      const res = await SavedMessagesServices.editMessage(formData, { decrypt: false });
      return await (res.code === 200 ? Promise.resolve(res) : Promise.reject(res));
   }

   async getMessage(offset = 0, limit = 20) {
      const timestamp = new Date().getTime();
      const msisdn = profile.username;
      const token = profile.token;
      const security = formatter.encrypt(`${msisdn}${offset}${limit}${token}${timestamp}`, true);
      const data = {
         params: {
            msisdn,
            offset,
            limit,
            timestamp,
            security,
            revision: clientInfo.revision,
            languageCode: language.language,
            countryCode: clientInfo.country
         },
      };
      const res = await SavedMessagesServices.getListMesage(data, { decrypt: false });
      return await (res.code === 200 ? Promise.resolve(res) : Promise.reject(res));
   }

   async savedMessage(msg) {
      const { content, id, topic } = msg;
      const timestamp = new Date().getTime();
      const token = profile.token;
      const msisdn = profile.username;
      const threadId = Topic.getThreadId(topic);
      const security = formatter.encrypt(`${msisdn}${msisdn}${threadId}${token}${timestamp}`, true);
      const formData = new FormData();
      formData.set('msisdn', msisdn);
      formData.set('messageId', id);
      formData.set('data', content);
      formData.set('resource', clientInfo.platform);
      formData.set('timestamp', timestamp);
      formData.set('security', security);
      formData.set('clientType', clientInfo.platform);
      formData.set('revision', clientInfo.revision);
      formData.set('languageCode', language.language);
      formData.set('countryCode', clientInfo.country);
      formData.set('threadId', threadId);
      formData.set('typeThread', Topic.getMessageType(topic))
      const res = await SavedMessagesServices.saveMessage(formData, { decrypt: false });
      return await (res.code === 200 ? Promise.resolve(res) : Promise.reject(res));
   }

}

export default new SavedMessages;